<template>
  <div class="d-flex align-items-center">
    <div class="icon-preview me-2">
      <img
        v-if="props.modelValue && props.modelValue.length > 0"
        :src="renderIconColumns(props.modelValue)"
        alt="icon"
        height="32px"
        width="32px"
      />
      <img
        v-else
        src="@/assets/icon/none-icon-svg.svg"
        alt="icon"
        height="32px"
        width="32px"
      />
    </div>

    <select-icons-columns
      :listIcons="listIconsColumns"
      @setIcon="setIcon"
    ></select-icons-columns>

    <span style="margin: 0 5px">{{ $t("t-or") }}</span>
    <label for="idInput" class="label-upload-icons">
      <img
        src="@/assets/icon/upload_white.svg"
        alt="upload"
        height="20"
        width="20"
      />
      <span>{{ $t("t_upload") }}</span>
    </label>

    <input
      type="file"
      :accept="props.accept"
      id="idInput"
      style="display: none"
      @change="uploadIconColumns"
    />
  </div>
</template>

<script setup>
import { ref, onMounted, defineProps, defineEmits } from "vue";
import mushroom from "cem-primary-api";
import toastr from "toastr";
import { useI18n } from "vue-i18n";
import MethodService from "@/service/MethodService";
import SelectIconsColumns from "./SelectIconsColumns.vue";

const props = defineProps({
  modelValue: {
    type: String,
    default: "",
  },
  accept: {
    type: String,
    default: ".jpg, .png, .jpeg, .svg, .ico",
  },
});

const emit = defineEmits(["update:modelValue", "setIcon"]);

const { t } = useI18n();
const listIconsColumns = ref([]);

const getListIconsColumns = async () => {
  try {
    const response = await mushroom.icon.getAllAsync();
    if (response.result?.length > 0)
      listIconsColumns.value = response.result.map((item) => item.file_id);
  } catch (e) {
    console.error("Có lỗi: %o", e);
  }
};

const renderIconColumns = (iconId) => {
  if (!iconId) return;
  return mushroom.$file.linkBuilder.thumb.id(iconId).build();
};

const setIcon = (fileId) => {
  emit("update:modelValue", fileId);
  emit("setIcon", fileId);
};

const updateIconId = async (id) => {
  const icon_object = {
    file_id: id,
  };
  try {
    await mushroom.icon.createAsync(icon_object);
    await getListIconsColumns();
  } catch (e) {
    MethodService.showError(e.code);
  }
};

const uploadIconColumns = async (event) => {
  try {
    const file = event.target.files[0];
    if (!file) return;

    let nameImage = file.name;
    let typeImage = nameImage?.slice(nameImage.lastIndexOf(".")).toLowerCase();

    const validTypes = props.accept
      .split(",")
      .map((item) => item.trim().toLowerCase());
    if (typeImage && !validTypes.includes(typeImage)) {
      toastr.warning(t("t_select_format_image"));
    } else {
      let res = await mushroom.$file.uploadAsync({
        file: file,
      });
      if (res.result) {
        emit("update:modelValue", res.result);
        emit("setIcon", res.result);
        await updateIconId(res.result);
      }
    }
  } catch (e) {
    MethodService.showError(e.code);
  }
};

onMounted(async () => {
  await getListIconsColumns();
});
</script>

<style scoped>
.preview-img {
  width: 25px;
  height: 25px;
  object-fit: contain;
}
.label-upload-icons {
  display: flex;
  align-items: center;
  gap: 5px;
  background-color: #f7b84b;
  color: white;
  padding: 0px 10px;
  border-radius: 5px;
  cursor: pointer;
  white-space: nowrap;
  margin-bottom: 0;
}
.label-upload-icons.disabled {
  background-color: #b4b4b4;
  cursor: no-drop;
}
</style>
